import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** tailwind-merge taught about the custom type scale, elevations and radii in styles/globals.css. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['2xs', 'xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl', '3xl'],
      shadow: ['elev-0', 'elev-1', 'elev-2', 'elev-3', 'elev-4', 'inset'],
      radius: ['xs', 'sm', 'md', 'lg', 'xl', 'full'],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
